module.exports = __webpack_public_path__ + "static/media/logo_footer.d03352f6.svg";